const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20news%20video%20thumbnail%20style%2C%20dramatic%20red%20carpet%20scene%20with%20celebrities%20posing%2C%20play%20button%20overlay%2C%20bold%20graphic%20design%2C%20vibrant%20colors%2C%20editorial%20photography%2C%20dynamic%20composition%2C%20media%20content%20style&width=900&height=600&seq=media-chigua-01&orientation=landscape',
    title: '【独家深度】顶流恋情时间线全还原：从暧昧到实锤的180天',
    duration: '12:35',
    views: '128.5万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=TV%20show%20behind%20the%20scenes%20drama%2C%20hosts%20having%20heated%20discussion%2C%20studio%20crew%20watching%2C%20dramatic%20lighting%2C%20reality%20show%20set%2C%20video%20thumbnail%20style%2C%20bold%20colors%2C%20entertainment%20media&width=900&height=600&seq=media-chigua-02&orientation=landscape',
    title: '【综艺翻车】盘点今年最尴尬的综艺名场面TOP10',
    duration: '08:22',
    views: '96.3万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Fashion%20week%20runway%20highlights%20montage%2C%20models%20and%20celebrities%2C%20glamorous%20atmosphere%2C%20luxury%20brand%20logos%20blurred%2C%20editorial%20style%20video%20thumbnail%2C%20vibrant%20fashion%20photography%2C%20dynamic%20composition&width=900&height=600&seq=media-chigua-03&orientation=landscape',
    title: '【红毯全纪录】年度盛典3小时超长完整版，名场面合集',
    duration: '15:48',
    views: '85.7万',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
              吃瓜视频
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
              吃瓜视频
            </h2>
            <p className="text-foreground-600 text-sm max-w-lg mx-auto">
              明星大瓜独家视频解说，视觉化呈现娱乐圈最新内幕
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {mediaItems.map((item) => (
              <div
                key={item.title}
                className="group rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 overflow-hidden transition-all duration-200 cursor-pointer"
              >
                <div className="relative overflow-hidden aspect-video">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                    loading="lazy"
                    onError={(e) => {
                      (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                    }}
                  />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                    <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 group-hover:bg-primary-500 group-hover:scale-110 transition-all duration-200">
                      <i className="ri-play-fill text-white text-xl ml-0.5"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-3 right-3 px-2.5 py-1 rounded-md bg-black/70 text-white text-xs font-mono">
                    {item.duration}
                  </div>
                  <div className="absolute bottom-3 left-3 flex items-center gap-1 px-2.5 py-1 rounded-md bg-black/70 text-white text-xs">
                    <i className="ri-eye-line text-xs"></i>
                    {item.views}
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="font-heading font-bold text-sm md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {item.title}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}